import StandardCard from "./StandardCard.card.jsx";
import RoundedIcon from "../buttons/roundedIcon.component.jsx";

export default function PhonebookCard(props) {
  return (
    <StandardCard className={"standardCard--info--phone col-10 mr-3"}>
      <div className="d-flex">
        <h3 className={"mb-2 mr-3"}>{props.name}</h3>
        <RoundedIcon
          icon={["fal", "phone"]}
          divClass={"roundedIcon--primary ml-auto"}
          iconClass={"roundedIcon--primary__icon"}
          onClick={() => {
            window.location.href = `tel:${props.phone.replace(/[^0-9]/g, "")}`;
          }}
        />
      </div>
      <div>
        <p className={"mb-2"}>{props.description}</p>
        <p className={"mb-2"}>{props.phone}</p>
      </div>
    </StandardCard>
  );
}
